import { KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { removeEmptyParagraphs } from '../../commons/preprocess-paragraphs';
import { mapParagraphs } from './AllParagraphs';

export function mapTimeline(
  input: TimelineFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Timeline'> {
  return {
    key: 'Timeline',
    input: {
      groups: removeEmptyParagraphs(input.groups)
        .filter(cleanList)
        .map((group) => ({
          groupTitle: group.groupTitle,
          elements: removeEmptyParagraphs(group.elements)
            .filter(cleanList)
            .map((timelineElement) => {
              return {
                elementTitle: timelineElement.elementTitle,
                anchorLabel: timelineElement.anchorLabel,
                body: {
                  items: mapParagraphs(timelineElement.body.filter(cleanList)),
                },
              };
            }),
        })),
    },
  };
}
